import { useCallback, useState } from 'react';
export function useForwarder() {
    const [config, setConfig] = useState(null);
    const open = useCallback((config) => setConfig(config), []);
    const close = useCallback(() => setConfig(null), []);
    return [open, close, config];
}
